import { render, staticRenderFns } from "./PublicScreen.vue?vue&type=template&id=2b883dd9"
import script from "./PublicScreen.vue?vue&type=script&lang=js"
export * from "./PublicScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports